<template>
  <div>
    <b-modal id="listAttendenceswapModel" hide-footer centered size="xl" title="Attendance Swap">
      <b-form-group>
        <b-form-select placeholder="Select Faculty" v-model="attendenceSwapFilter"
          :options="attendenceSwapOptions"></b-form-select>
        <div>
          <h4>Mutual Swap</h4>
          <table class="table table-bordered table-striped">
            <tr>
              <th class="text-center" colspan="5">Sl No</th>
              <th class="text-center" colspan="40">
                Intiated by
              </th>
              <th class="text-center" colspan="40">
                Intiated for
              </th>
              <th class="text-center" colspan="10">
                Reason
              </th>
              <th class="text-center" colspan="5">
                Status
              </th>
            </tr>
            <tr>
              <th class="text-center" colspan="5">
              </th>
              <th class="text-center" colspan="8">
                Faculty
              </th>
              <th class="text-center" colspan="8">
                Date
              </th>
              <th class="text-center" colspan="8">
                Class
              </th>
              <th class="text-center" colspan="8">
                Session
              </th>
              <th class="text-center" colspan="8">
                Course
              </th>
              <th class="text-center" colspan="8">
                Faculty
              </th>
              <th class="text-center" colspan="8">
                Date
              </th>
              <th class="text-center" colspan="8">
                Class
              </th>
              <th class="text-center" colspan="8">
                Session
              </th>
              <th class="text-center" colspan="8">
                Course
              </th>
              <th class="text-center" colspan="10">
              </th>
              <th class="text-center" colspan="5">
              </th>
            </tr>
            <tr v-for="(attendence,
              attendenceIndex) in attendenceSwapArray" :key="attendenceIndex">
              <td colspan="5">{{ attendenceIndex + 1 }}</td>
              <td colspan="8">
                <p v-for="(faculty,
                  facultyIndex) in attendence['fromfaculties']" :key="facultyIndex">{{
                  faculty['first_name'] + faculty['last_name'] }}
                  <span
                    v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 0" class="text-danger">(Pending Approval)</span>
                  <span
                    v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 1">(Approved)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 3">(Approved)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                  <span v-if="faculty['pivot']['intiated_by'] == 1">-Intiated</span>
                </p>
              </td>
              <td colspan="8"><span v-if="attendence['from_date']">{{
                  moment(attendence['from_date'], 'YYYY-MM-DD').format('DD/MM/YYYY') }}</span></td>
              <td colspan="8"><span v-if="attendence['fromsubgroup']">{{ attendence['fromsubgroup']['name'] }}</span>
              </td>
              <td colspan="8"><span v-if="attendence['fromsession']">{{ attendence['fromsession']['name'] }}</span></td>
              <td colspan="8">
                <p v-for="(course,
                  cIndex) in attendence['fromcourses']" :key="cIndex">
                  {{ course['code'] }}
                </p>
              </td>
              <td colspan="8">
                <p v-for="(faculty,
                  facultyIndex) in attendence['tofaculties']" :key="facultyIndex">
                  {{ faculty['first_name'] + faculty['last_name'] }}
                  <span v-if="faculty['pivot']['approval_status'] == 0" class="text-danger">(Pending Approval)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 3">(Approved)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                </p>
              </td>
              <td colspan="8"><span v-if="attendence['to_date']">{{
                  moment(attendence['to_date'], 'YYYY-MM-DD').format('DD/MM/YYYY') }}</span></td>
              <td colspan="8"><span v-if="attendence['tosubgroup']">{{ attendence['tosubgroup']['name'] }}</span></td>
              <td colspan="8"><span v-if="attendence['tosession']">{{ attendence['tosession']['name'] }}</span></td>
              <td colspan="8">
                <p v-for="(course,
                  cIndex) in attendence['tocourses']" :key="cIndex">
                  {{ course['code'] }}
                </p>
              </td>
              <td colspan="10"><span v-if="attendence['reason']">{{ attendence['reason'] }}</span></td>
              <td colspan="5" class="pt-2">

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="primary" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(attendence['toslot'], attendence['id'], 3)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 0 && attendence['fromstatus'] == 0 &&  attendence['approval_status'] == 0"
                  size="sm" variant="primary" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(attendence['fromslot'], attendence['id'], 1)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 0 && attendence['fromstatus'] == 0 && attendence['approval_status'] == 0"
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 3 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 1 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)"
                  size="sm" variant="secondary" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 2)">Cancel</b-button>

                <span
                  v-if="attendenceSwapFilter == 5 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <span
                  v-if="attendenceSwapFilter == 4 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <!-- <span
                  v-if="attendenceSwapFilter == 1 && attendence['approval_status'] == 1 && attendence['fromintiated'] == 0" class="text-danger">Pending Approval</span> -->

                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 2">Cancelled</span>
                
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 5">Reverted</span>

                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 3">Approved <br>
                
                  <b-button 
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 5)">Undo</b-button>
                
                </span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 4">Rejected</span>
              </td>
            </tr>
          </table>
        </div>

        <br>
        <div class="table-responsive">
          <h4>Session Handover</h4>
          <table class="table table-bordered table-striped">
            <tr>
              <th class="text-center" colspan="5">Sl No</th>
              <th class="text-center" colspan="40">
                Intiated by
              </th>
              <th class="text-center" colspan="20">
                Intiated for
              </th>
              <th class="text-center" colspan="10">
                Reason
              </th>
              <th class="text-center" colspan="15">
                Status
              </th>
            </tr>
            <tr>
              <th class="text-center" colspan="5">
              </th>
              <th class="text-center" colspan="10">
                Faculty
              </th>
              <th class="text-center" colspan="10">
                Date
              </th>
              <th class="text-center" colspan="10">
                Class
              </th>
              <th class="text-center" colspan="10">
                Session
              </th>
              <th class="text-center" colspan="10">
                Faculty
              </th>
              <th class="text-center" colspan="10">
                course
              </th>
              <th class="text-center" colspan="10">
              </th>
              <th class="text-center" colspan="15">
              </th>
            </tr>
           <tr v-for="(attendence,
              attendenceIndex) in filteredSessionHandovers" :key="attendenceIndex">

             
              <td colspan="5">{{ attendenceIndex +1}}</td>
              <td colspan="10">
                <span v-for="(faculty, facultyIndex) in attendence['fromcourse_user']" :key="facultyIndex">
                  <p>
                    {{ faculty['institution_user']['first_name'] + faculty['institution_user']['last_name'] }}
                    <span
                      v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 0" class="text-danger">(Pending Approval)</span>
                    <span
                      v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 1">(Approved)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 3 || faculty['pivot']['approval_status'] == 1">(Approved)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                    <span v-if="faculty['pivot']['intiated_by'] == 1">-Intiated</span>
                  </p>
                </span>
              </td>
              <td colspan="10"><span v-if="attendence['from_date']">{{
                  moment(attendence['from_date'], 'YYYY-MM-DD').format('DD/MM/YYYY') }}</span></td>
              <td colspan="10"><span v-if="attendence['fromsubgroup']">{{ attendence['fromsubgroup']['name'] }}</span>
              </td>
              <td colspan="10"><span v-if="attendence['fromsession']">{{ attendence['fromsession']['name'] }}</span>
              </td>
              <td colspan="10">
                <span v-for="(faculty, facultyIndex) in attendence['tocourse_user']" :key="facultyIndex">
                  <p>
                    {{ faculty['institution_user']['first_name'] + faculty['institution_user']['last_name'] }}
                    <span v-if="faculty['pivot']['approval_status'] == 0" class="text-danger">(Pending Approval)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 3 || faculty['pivot']['approval_status'] == 1">(Approved)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                  </p>
                </span>
              </td>
              <td colspan="10">
                <span v-for="(faculty, facultyIndex) in attendence['tocourse_user']" :key="facultyIndex">
                  <p>
                    {{ faculty['course']['name'] + '(' + faculty['course']['code'] + ')' }}
                  </p>
                </span>
              </td>
              <td colspan="10"><span v-if="attendence['reason']">{{ attendence['reason'] }}</span></td>
              <td colspan="15">
                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="primary" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['to_session_handover_approval_id'], attendence['toslot'], null, attendence['id'], 3)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="danger" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || (attendence['fromintiated'] != 1 &&attendenceSwapFilter == 1)) && attendence['approval_status'] == 0"
                  size="sm" variant="primary" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], attendence['fromslot'], null, attendence['id'], 1)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 0 && attendence['fromstatus'] == 0 && attendence['approval_status'] == 0"
                  size="sm" variant="danger" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 3 || attendenceSwapFilter == 1 ) 
                  && attendence['fromintiated'] == 1 
                  && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)"
                  size="sm" variant="secondary" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 2)">Cancel</b-button>

                <span
                  v-if="attendenceSwapFilter == 5 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <span
                  v-if="attendenceSwapFilter == 4 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <!-- <span v-if="attendenceSwapFilter == 1 && attendence['approval_status'] == 1" class="text-danger">Pending Approval</span> -->
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 2">Cancelled</span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 5">Reverted</span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 3">Approved <br>
                
                  <b-button 
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 5)">Undo</b-button>

                </span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 4">Rejected</span>
              </td>
            </tr>
          </table>
        </div>

      </b-form-group>
    </b-modal>
    <b-modal id="mutualswapModal" hide-footer centered size="md" title="Mutual Swap with">
      <div v-if="selectedSlots.sessions.length == 1">
        <b-form-group>
          <label class="required-label">Faculty:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select :class="{ 'form-group-error': $v.mutualswap.selectedFaculty.$error }" placeholder="Select Faculty"
              @change="mutualUserSubGroupList()" v-model="mutualswap.selectedFaculty" :options="facultyOptions">
            </b-form-select>
            <span class="input-error-message" v-if="!$v.mutualswap.selectedFaculty.required && $v.mutualswap.selectedFaculty.$dirty">Please Select a faculty!</span>
          </div>
        </b-form-group>
        <b-form-group>
          <label class="required-label">Class:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select placeholder="Select Class" v-model="mutualswap.selectedSubgroup" @change="checkClassType()" :options="subgroupOptions"></b-form-select>
            <span style="color:red" v-if="(mutualswap.selectedSubgroup != selectedSlots.subgroup_id) && mutualswap.selectedSubgroup && selectedSlots.subgroup_type == 'interdepartment_courses_group'">Mutual Swap can't support interdepartment course group</span>
            <span style="color:red" v-if="mutualswap.from_schedules_length > 1 && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)">Can't proceed mutual swap, Multiple faculties are mapped in from slot</span>
          </div>
        </b-form-group>
        <b-form-group v-if="selectedSlots.subgroup_type != 'interdepartment_courses_group' && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id) && mutualswap.from_schedules_length == 1">
          <label class="required-label">From Courses(slot1)</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select placeholder="Select Course" v-model="mutualswap.selectedFromCourse" :options="mutualSwapFromCourseOptions"></b-form-select>
          </div>
        </b-form-group>
        <b-form-group >
          <label class="required-label">Date:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-datepicker placeholder="Select Date" :min="mutualswapMinDate" :max="mutualswapMaxDate" @input="mutualswapSessionlist" v-model="mutualswap.selectedDate"></b-form-datepicker>
          </div>
        </b-form-group>
        <span style="color:red" v-if="sessionOptions.length == 0 && mutualswap.selectedDate">The selected faculty does not have session assigned on {{ mutualswap.selectedDate }}</span>
        <b-form-group v-if="sessionOptions.length>0 && mutualswap.selectedDate && (mutualswap.selectedSubgroup==selectedSlots.subgroup_id || selectedSlots.subgroup_type!='interdepartment_courses_group')">
          <label class="required-label">Session:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select :class="{ 'form-group-error': $v.mutualswap.selectedSession.$error }" placeholder="Select Session" @change="checkSessionSwapped()" v-model="mutualswap.selectedSession" :options="sessionOptions"></b-form-select>
            <span class="input-error-message" v-if="!$v.mutualswap.selectedSession.required && $v.mutualswap.selectedSession.$dirty">Please Select a session!</span>
          </div>
        </b-form-group>

        <span class="text-danger" v-if="mutualswap.selectedSession && mutualswap.swapped_session == 1">
          This session has already been swapped.
        </span>

        <span style="color:red" v-if="mutualswap.to_schedules_length > 1 && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)">Can't proceed mutual swap, Multiple faculties are mapped in to slot</span>
        <b-form-group v-if="selectedSlots.subgroup_type != 'interdepartment_courses_group' && sessionOptions.length > 0 && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)">
          <label class="required-label">To Courses(slot2)</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select placeholder="Select Course" v-model="mutualswap.selectedToCourse" :options="mutualSwapToCourseOptions"></b-form-select>
          </div>
        </b-form-group>
        <b-form-group v-if="(mutualswap.selectedSubgroup != selectedSlots.subgroup_id && mutualswap.to_schedules_length == 1 && sessionOptions.length > 0 && mutualswap.selectedSubgroupType != 'interdepartment_courses_group') || (mutualswap.selectedSubgroup == selectedSlots.subgroup_id && sessionOptions.length > 0 && mutualswap.selectedSubgroupType != 'interdepartment_courses_group')">
          <label class="required-label">Reason(minimum 10 character):</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-input :class="{ 'form-group-error': $v.mutualswap.reason.$error }" placeholder="Enter Reason" v-model="mutualswap.reason"></b-form-input>
            <span class="input-error-message" v-if="!$v.mutualswap.reason.required && $v.mutualswap.reason.$dirty">Please Enter reason!</span>
          </div>
        </b-form-group>

        <div class="d-flex justify-content-between" v-if="sessionOptions.length > 0 && ((mutualswap.selectedSubgroup==selectedSlots.subgroup_id || selectedSlots.subgroup_type!='interdepartment_courses_group'))">
          <span v-if="swapRequestSave" class="text-success">Swap Request Saving..........</span>
          <b-button class="btn btn-success" size="sm" @click="initiateSwapRequest()" 
          :disabled="mutualswap.swapped_session == 1 || swapRequestSave ||!mutualswap.reason || (mutualswap.reason && mutualswap.reason.length < 10) || (mutualswap.to_schedules_length > 1 && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)) || (mutualswap.from_schedules_length > 1 && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id))">Initiate Swap Request</b-button>
          <b-button @click="$bvModal.hide('mutualswapModal')" variant="danger" size="sm">Cancel</b-button>
        </div>

      </div>
      <span v-else>Mutual swap/session handover will not work for multiple sessions</span>
    </b-modal>

    <b-modal id="sessionHandoverModal" hide-footer centered size="md" title="Session Handover for">
      <div v-if="selectedSlots.sessions.length == 1">
        <b-form-group>
          <label class="required-label">Course and Faculty</label>
          <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3" v-for="courseInstructor in courseInstructorArray"
              :key="courseInstructor.course_user_id">
              <b-form-checkbox v-if="!courseInstructor.course_user_deleted_at" v-model="sessionhandover.course_user_ids" :value="courseInstructor.course_user_id"
                @change="updateSessioncourseuserid(courseInstructor.course_user_id)"> {{
                  courseInstructor.course_code }}-<small>{{
                  courseInstructor.instructor
                }}</small>
              </b-form-checkbox>
            </div>
            <br />
          </div>
        </b-form-group>
        <b-form-group>
          <label class="required-label">Reason(minimum 10 character):</label>
          <div style="
              border: 2px solid #eeeeeb;
              border-left-style: none;
              border-right-style: none;
            " class="p-2">
            <b-form-input placeholder="Enter Reason" v-model="sessionhandover.reason"></b-form-input>
          </div>
        </b-form-group>
        <div class="d-flex justify-content-between">
          <b-button class="btn btn-success"
            :disabled="!sessionhandover.reason || (sessionhandover.reason && sessionhandover.reason.length < 10)"
            size="sm" @click="sessionhandoverRequest()">Intiate Session handover Request</b-button>
          <b-button @click="$bvModal.hide('sessionHandoverModal')" variant="danger" size="sm">Cancel</b-button>
        </div>
      </div>
      <span v-else>Mutaual swap/session handover will not work for multiple session </span>
    </b-modal>

    <b-col sm="12">

      <div class="row justify-content-center">
        <div class="attendance-table-container">
          <b-col class="border border-dark py-2">
            <div>
              <b-row class="d-flex justify-content-between">
                <ul>
                  <li style="border:none;">Mark Attendance Using Calender? <b-link
                      @click="$bvModal.show('customDateAttendanceMarkModel')"> Click here to proceed</b-link>
                  </li>
                  <li style="border:none;">Swap Session/Session Handover Log? <b-link @click="attendenceSwapList()"> Click
                      here to proceed</b-link>
                  </li>
                  <li style="border:none;">Want To Edit/Delete Attendance? <b-link
                      @click="openEditCourseAttendanceFormWithReportMainTab"> Click here to proceed</b-link>
                  </li>
                  <li style="border:none;">Download my schedule pdf report<b-link @click="downloadMySchedulePdf">
                      {{ loadingPdf ? 'Please wait...' : 'Click to download' }}</b-link>
                  </li>
                </ul>

                <ul class="mr-2">
                  <li style="border:none; margin-bottom: 1px;"> <span class="px-3  mr-1 border-success"
                      style="border: 2px solid ;"></span>Scheduled, Attendance Marked
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3  mr-1 border-danger"
                      style="border: 2px solid;"></span>Scheduled, Attendance Not Marked
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3  mr-1 border-warning"
                      style="border: 2px solid ;"></span>Scheduled, Attendance Marked by Another Faculty
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3  mr-1 border-info"
                      style="border: 2px solid ;"></span>Not Scheduled, Attendance Marked.
                  </li>

                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3 holiday-schedule  mr-1 border-dark"
                      style="border: 2px solid;"></span>Holiday.
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3 suspended-schedule  mr-1 border-dark"
                      style="border: 2px solid;"></span>Class Suspended.
                  </li>
                </ul>
              </b-row>
              <b-modal id="customDateAttendanceMarkModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
                hide-header-close hide-footer hide-header centered size="md">
                <customDateAttendanceMarking :sessionsProp="sessions"
                  @markNewAttendance="markNewAttendanceFromCustomDate" />
              </b-modal>
              <b-modal id="unlockAttendanceModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
                hide-header-close hide-footer hide-header centered size="md">
                <div>
                  <b-col sm="12">
                    <h3 style="text-align: center; font-size:18px !important;">
                      Unlock Attendance
                    </h3>
                    <b-form-group>
                      <label class="required-label" for="">Reason (Minimum 10 character):</label>
                      <b-form-input id="input-1" v-model="unlock_reason" type="text"
                        placeholder="Enter Reason"></b-form-input>
                    </b-form-group>
                    <b-button @click="$bvModal.hide('unlockAttendanceModel')" class="mr-3"
                      variant="danger">Cancel</b-button>
                    <b-button class="ml-2" variant="success" :disabled="!enable_unlock_proceed || (unlock_reason && unlock_reason.length < 10)"
                      size="sm" @click="submitattendanceunlock()">Proceed</b-button>
                  </b-col>
                </div>
              </b-modal>
            </div>
            <h5 class="text-center" style="font-size:16px !important; color: #010177;">
              My Schedule
            </h5>
          </b-col>
          <table v-if="(viewMySchedule === true)" class="table table-bordered black-border "
            style="width: auto !important; text-align: center;">
            <thead style="position: sticky;top: 0;">
              <tr>
                <th :colspan="(mySchedulesEnabledSessionIds.length + 1)" style="color: #000950;"
                  class="text-center  bg-white">
                  <span v-if="selectedSlots.course_id == ''">Please choose slots to mark attendance - swap session</span>
                

                  <span v-if="!selectedSlots.swapped && !selectedSlots.handover">
                    <span v-if="!selectedSlots.swap_pending">
                      <b-button v-if="selectedSlots.course_id != '' && !selectedSlots.already_marked" style="margin-right:10px;" class="ml-2" variant="primary" size="sm" @click="showMutualSwapPopup()">Initiate Mutual Swap</b-button>
                    </span>
                    <span v-else-if="selectedSlots.course_id != ''" class="text-danger">Swap request cannot be initiated because a request is already pending.<br></span>

                    <span v-if="!selectedSlots.handover_pending">
                      <b-button v-if="selectedSlots.course_id != '' && !selectedSlots.already_marked" style="margin-right:10px;" class="ml-2" variant="primary" size="sm" @click="sessionHandover()">Initiate Session Handover</b-button>
                    </span>
                    <span v-else-if="selectedSlots.course_id != ''" class="text-danger">Session handover request cannot be initiated because a request is already pending.<br></span>
                  </span>
                  <span v-else>
                    <span class="text-success" v-if="selectedSlots.course_id != '' && selectedSlots.swapped">Already Swapped</span>    
                    <span class="text-success" v-if="selectedSlots.course_id != '' && selectedSlots.handover">Session already handed over.</span>
                  </span>

                  <span v-if="selectedSlots.course_id != ''&& !selectedSlots.lock">
                    <span class="text-info" v-if="selectedSlots.holiday">This date is already marked as holiday. Do you
                      still want to proceed with attendance marking?<br></span>
                    <span class="text-info" v-if="selectedSlots.suspend">This session has already been suspended. Do you
                      still want to proceed with attendance marking?<br></span>
                    <i class="blink_me fas fa-calendar mr-3"></i>

                    {{ selectedSlots.already_marked ? 'Edit ' : 'Mark new '
                    }}attendance for
                    {{ courses[selectedSlots.course_id].name }}-{{ courses[selectedSlots.course_id].usersubgroup.code }}
                    on
                    {{ moment(selectedSlots.date, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
                    and sessions:
                    <span v-for="sessionId in selectedSlots.sessions" :key="sessionId">{{ sessionObjects[sessionId].name
                      }},</span>
                    <b-button class="ml-2" variant="success" size="sm" @click="markNewAttendance">Proceed</b-button>
                  </span>
                  <span v-if="selectedSlots.course_id != '' &&  selectedSlots.lock">
                    <span class="text-info">Attendance locked for this session.<span
                        v-if="!selectedSlots.unlock_Pending">Send Unlock Request?</span>
                      <span v-else>Unlock request is pending</span>
                    </span>
                    <b-button class="ml-2" variant="success" size="sm" v-if="!selectedSlots.unlock_Pending"
                      @click="$bvModal.show('unlockAttendanceModel')">Unlock</b-button>
                  </span>
                  <span v-b-tooltip.hover :title="'Refresh Schedule Table'" style="float: right;"
                    @click="getMySchedulesAttendances()">
                    <i class="fas fa-sync"></i>
                  </span>

                </th>
              </tr>
              <tr>
                <th class="text-center text-white bg-dark" style="min-width: 100px;">
                  <i class="fas fa-user-clock fa-lg"></i>
                </th>
                <th v-for="sessionId in mySchedulesEnabledSessionIds" :key="sessionId" style="min-width: 100px;"
                  class="text-center text-white bg-dark">
                  {{ sessionObjects[sessionId].name }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(sessionsScheduleAtts, date, index) in dateSessionScheduleAtts"
                :ref="(new Date().toISOString().slice(0, 10) == date) ? 'todaySchedule' : ''" :key="date" :style="index === 0 && new Date(date).toDateString() !== new Date().toDateString() ? { filter: 'grayscale(100%)', opacity: '0.6', pointerEvents: 'none' } : {}">
                <td>
                  {{ moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') }} <br>{{ weekdayNames[new Date(date).getDay()] }}
                </td>
                <td
                  :class="{ 'selected-slot': (selectedSlots.sessions.includes(sessionId) && selectedSlots.date == date) }"
                  v-for="sessionId in mySchedulesEnabledSessionIds" :key="sessionId" style="padding: 1px">

                  <div style="cursor: pointer; margin: 1px;"
                    v-for="(scheduleData, scheduleIndex) in (sessionsScheduleAtts[sessionId] && sessionsScheduleAtts[sessionId].schedules || [])"
                    :key="scheduleIndex"
                    @click="selectScheduleSlot( scheduleData['student_attendances'], date, sessionId, scheduleData.course_id, scheduleData.attendance_status, scheduleData.holiday != null, scheduleData.suspend != null, scheduleData.lock, scheduleData.pending, scheduleData.usersubgroup_id,
                     courses[scheduleData.course_id].usersubgroup.type, scheduleData.swap_pending, scheduleData.handover_pending, scheduleData.swapped, scheduleData.handover)"
                    v-b-popover.hover.top="(scheduleData.suspend != null ? ' Class Suspended: ' + scheduleData.suspend + ', ' : '') +
                (scheduleData.holiday != null ? 'Holiday: ' + scheduleData.holiday + ', ' : '') +
                courses[scheduleData.course_id].name +
                '-' +
                courses[scheduleData.course_id].usersubgroup.name +
                '-' + courses[scheduleData.course_id].usersubgroup.usergroup.name
                + (scheduleData.attendance_status == '' ? '' :
                  ((scheduleData.attendance_status == 'marked_for_schedule_by_someone' ?
                    (' marked by' + scheduleData.mark_by_someone) : ' marked by yourself')))" :class="{
        'c-border border-danger': (scheduleData.attendance_status == ''),
        'c-border border-success text-success': (scheduleData.attendance_status == 'marked_for_schedule'),
        'c-border border-warning text-success': (scheduleData.attendance_status == 'marked_for_schedule_by_someone'),
        'holiday-schedule': scheduleData.holiday != null, 'suspended-schedule': scheduleData.suspend != null
      }">
                    <span v-if="scheduleData.class_type" style="color : red;font-size:8px !important;">
                      {{ scheduleData.class_type }}<br></span> {{ courses[scheduleData.course_id].code }}-{{
                        courses[scheduleData.course_id].usersubgroup.code }}
                        <span v-if="scheduleData.swapped == 1">-Swapped</span>
                        <span v-if="scheduleData.handover == 1">-Session handover</span>
                        <span
                      style="color : blue;font-size:8px !important;" v-if="scheduleData.delivery_method"><br>{{
                        scheduleData.delivery_method }}</span>
                  </div>

                  <!-- marked non chedule courses  -->
                  <div v-if="(sessionsScheduleAtts[sessionId] && sessionsScheduleAtts[sessionId].non_schedule_marked_courses.length > 0)"
                    style="height: 35px;">
                    <div @click="selectScheduleSlot(null, date, sessionId, courseId
                      , 'marked_for_not_scheduled', null, null, false, false, courses[courseId].usersubgroup.id, null, false, false, false, false)" style="cursor: pointer; margin: 1px;"
                      class="c-border border-info"
                      v-for="(courseId, courseIndex) in (sessionsScheduleAtts[sessionId] && sessionsScheduleAtts[sessionId].non_schedule_marked_courses)"
                      :key="courseIndex" v-b-popover.hover.top="
                        courses[courseId].name +
                        '-' +
                        courses[courseId].usersubgroup.name + '-' + courses[courseId].usersubgroup.usergroup.name + ' marked by yourself out of schedule. please use edit attendance at the top to edit this attendance '
                      ">
                      {{ courses[courseId].code }}-{{ courses[courseId].usersubgroup.code }}
                    </div>
                  </div>

                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" :class="viewLoadMore ? '' : 'd-none'">
            <button class="btn btn-secondary" :class="isLoadingMore == null ? 'd-none' : ''" @click="getMySchedulesAttendances(true)"> {{ isLoadingMore ? 'Loading…' : 'Load More' }}</button>
          </div>
        </div>
      </div>
      <div v-if="(viewMySchedule === null)">Loading Schedules...</div>
      <div v-if="viewMySchedule === false" class="text-danger text-center py-2">
        <b>Timetable is not updated by Faculty adviser</b>
      </div>

    </b-col>
    <b-modal id="studentsAttendanceMarkingFormModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
      hide-footer hide-header-close hide-title modal-class="markAttendence">
      <studentsAttendanceMarkingForm :dataToMarkAttendanceFor="markAttendanceFor"
        @successAttendanceMarkForm="successAttendanceMarkForm" @cancelAttendanceMarkForm="cancelAttendanceMarkForm" />
    </b-modal>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import axios from "axios";
import studentsAttendanceMarkingForm from './studentsAttendanceMarkingForm.vue';
// import moment from "moment";
import customDateAttendanceMarking from './customDateAttendanceMarking.vue';
export default {
  props: ["propSessions"],
  async created() {
    // this.sessions = this.propSessions;
    // if (this.sessions.length < 1) {
    await this.getSessions();
    // } else {
    //   this.sessionObjects = {};
    //   this.sessions.forEach(session => {
    //     this.sessionObjects[session.id] = session;
    //   });
    // }
    await this.getMySchedulesAttendances();
  },
  components: {
    customDateAttendanceMarking,
    studentsAttendanceMarkingForm,
  },
  data() {
    return {
      start_date : '',
      courseInstructorArray: [],
      swapRequestSave: false,
      facultyOptions: [],
      subgroupOptions: [],
      courseOptions: [],
      mutualSwapFromCourseOptions: [],
      mutualSwapToCourseOptions: [],
      sessionOptions: [],
      mutualswap: {
        to_schedules_length: null,
        from_schedules_length: null,
        selectedFaculty: null,
        selectedSubgroup: null,
        selectedSession: null,
        selectedDate: null,
        selectedCourse: null,
        selectedSubgroupType: null,
        reason: null,
        swapped_session: false,
        selectedFromCourse: null,
        selectedToCourse: null,
        fromslot: null,
        toslot: null,
        from_swap_approval_id: null,
        to_swap_approval_id: null,
        fromstatus: null,
        tostatus: null,
        fromintiated: null,
        tointiated: null,
      },
      sessionhandoverarray: [],
      sessionhandover: {
        selectedFaculty: null,
        selectedclass: null,
        reason: null,
        course_user_ids: [],
        fromslot: null,
        toslot: null,
        from_session_handover_approval_id: null,
        to_session_handover_approval_id: null,
        fromstatus: null,
        tostatus: null,
        fromintiated: null,
        tointiated: null,
      },
      attendenceSwapOptions: [
        { value: 1, text: "All Request" },
        { value: 2, text: "Received Pending Request" },
        { value: 3, text: "Send Pending Request" },
        { value: 4, text: "Action taken received request" },
        { value: 5, text: "Action taken send request" },
      ],
      attendenceSwapArray: [],
      attendenceSwapFilter: 2,
      faculty: null,
      viewMySchedule: null,
      isLoadingMore: null,
      viewLoadMore: false,
      dateSessionScheduleAtts: {},
      courses: {},
      sessions: [],
      sessionObjects: {},
      mySchedulesEnabledSessionIds: [],
      unlock_reason:'',
      // badgeColors: [
      //   'badge-red', 'badge-orange', 'badge-yellow', 'badge-green', 'badge-blue', 'badge-pink', 'badge-purple', 'badge-brown', 'badge-black', 'badge-white'
      // ],
      weekdayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      selectedSlots: {
        student_attendances:[],
        date: '',
        sessions: [],
        course_id: '',
        // confirm_text: '', // pass to att mark form
        already_marked: false,
        holiday: false,
        suspend: false,
        subgroup_type: null,
        lock: false,
        subgroup_id: null,
        unlock_Pending: false,
        swap_pending: false,
        swapped: false,
        handover: false,
        handover_pending: false
      },
      markAttendanceFor: { // dedicated to pass data to  attendance mark form from this and other componant
        date: '',
        sessions: [],
        course_id: '',
        confirm_text: '',
        // already_marked: false,
      },
      loadingPdf: false,
      enable_unlock_proceed: true
    };
  },
  validations: {
    mutualswap: {
      selectedFaculty: {
        required,
      },
      selectedSession: {
        required,
      },
      reason: {
        required,
      },
    },
  },
  computed: {
    filteredSessionHandovers() {
      return this.sessionhandoverarray.filter(attendance => {
        const fromMatch = attendance.fromcourse_user?.some(
          user => user.pivot && user.pivot.faculty === this.mutualswap.faculty
        );

        const toMatch = attendance.tocourse_user?.some(
          user => user.pivot && user.pivot.faculty === this.mutualswap.faculty
        );

        return fromMatch || toMatch;
      });
    },
    mutualswapMinDate() {
      var date = new Date();
      return date;
    },
    mutualswapMaxDate() {
      var date = new Date();
      date.setDate(date.getDate() + 14);
      return date;
    },
  },
  watch: {
    "attendenceSwapFilter": function () {
      this.attendenceSwapList();
    },
  },
  methods: {
     async attendenceSwapList() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps?attendenceSwapFilter=${this.attendenceSwapFilter}`;
      try {
        const response = await axios.get(url);
        this.attendenceSwapArray = [];
        this.sessionhandoverarray = [];

        // Set the current faculty ID for the authenticated user
        this.mutualswap.faculty = response.data.faculty;

        // Extract the list of mutual swaps from the response
        const mutualSwaps = response.data.mutual_swap;
        mutualSwaps.forEach((swap) => {
          // Reset all mutual swap properties for each new swap
          Object.assign(this.mutualswap, {
            toslot: null, tostatus: null, tointiated: null, to_swap_approval_id: null,
            fromslot: null, fromstatus: null, fromintiated: null, from_swap_approval_id: null,
          });

          // Iterate through 'fromfaculties' to find relevant details for the current faculty
          swap.fromfaculties.forEach((from) => {
            if (from.faculty === this.mutualswap.faculty) {
              Object.assign(this.mutualswap, {
                fromslot: from.slot, // Slot (0 for "sent", 1 for "received")
                fromstatus: from.approval_status, // Approval status for the "from faculty"
                fromintiated: from.pivot.intiated_by, // Whether the request was initiated by the "from faculty" (1 = initiated)
                from_swap_approval_id: from.pivot.id, // Approval ID for the "from faculty"
              });
            }
          });

          // Iterate through 'tofaculties' to find relevant details for the current faculty
          swap.tofaculties.forEach((to) => {
            if (to.faculty === this.mutualswap.faculty) {
              Object.assign(this.mutualswap, {
                toslot: to.slot, // Slot (0 for "sent", 1 for "received")
                tostatus: to.approval_status, // Approval status for the "to faculty"
                tointiated: to.pivot.intiated_by, // Whether the request was initiated by the "to faculty" (1 = initiated)
                to_swap_approval_id: to.pivot.id, // Approval ID for the "to faculty"
              });
            }
          });

          // Define filter conditions based on the attendance swap filter type
          const filterConditions = [
            // Filter 1: All Requests
            this.attendenceSwapFilter === 1 &&
            ((this.mutualswap.to_swap_approval_id > 0 && swap.approval_status !== 0) || this.mutualswap.from_swap_approval_id > 0),

            // Filter 3: Sending Pending Request
            swap.fromfaculties.length > 0 && this.attendenceSwapFilter === 3 &&
            this.mutualswap.fromintiated === 1 && ([0, 1].includes(swap.approval_status) || this.mutualswap.from_swap_approval_id === null),

            // Filter 5: Action Taken on Sent Requests
            swap.fromfaculties.length > 0 && this.attendenceSwapFilter === 5 &&
            this.mutualswap.fromslot === 0 && this.mutualswap.fromintiated === 1 && ![0, 1].includes(swap.approval_status),

            // Filter 2: Received Pending Request
             swap.tofaculties.length > 0 && this.attendenceSwapFilter === 2 &&
            (swap.approval_status === 1 
            || (this.mutualswap.to_swap_approval_id === null && swap.approval_status === 0)),

            // Filter 4: Action Taken on Received Requests
            this.attendenceSwapFilter === 4 &&
            ((this.mutualswap.to_swap_approval_id && this.mutualswap.tostatus !== 0) ||
              (this.mutualswap.from_swap_approval_id && this.mutualswap.fromstatus !== 0)) &&
            swap.approval_status !== 0 && this.mutualswap.fromintiated !== 1,
          ];

          // If any filter condition matches, add the swap to the attendance swap array
          if (filterConditions.some((condition) => condition)) {
            this.attendenceSwapArray.push({
              id: swap.id, 
              fromfaculties: swap.fromfaculties, 
              fromsubgroup: swap.fromsubgroup, 
              fromcourses: swap.fromcourses, 
              tocourses: swap.tocourses, 
              fromsession: swap.fromsession, 
              from_date: swap.from_date, 
              tofaculties: swap.tofaculties,
              tosubgroup: swap.tosubgroup, 
              tosession: swap.tosession, 
              to_date: swap.to_date, 
              reason: swap.reason, 
              approval_status: swap.approval_status, 
              fromslot: this.mutualswap.fromslot,
              fromstatus: this.mutualswap.fromstatus, 
              fromintiated: this.mutualswap.fromintiated, 
              from_swap_approval_id: this.mutualswap.from_swap_approval_id, 
              toslot: this.mutualswap.toslot, 
              tostatus: this.mutualswap.tostatus, 
              tointiated: this.mutualswap.tointiated, 
              to_swap_approval_id: this.mutualswap.to_swap_approval_id, 
            });
          }
        });

        // Show the attendance swap list modal
        this.$bvModal.show('listAttendenceswapModel');



          var sessionhandover = response.data.session_hand_over;
          sessionhandover.forEach((handover) => {
            handover.fromcourse_user.forEach((from) => {
              if (from.institution_user_id == response.data.faculty) {
                this.sessionhandover.fromslot = from.pivot.slot;
                this.sessionhandover.fromstatus = from.pivot.approval_status;
                this.sessionhandover.fromintiated = from.pivot.intiated_by;
                this.sessionhandover.from_session_handover_approval_id = from.pivot.id;
              }
            });
            handover.tocourse_user.forEach((to) => {
              if (to.institution_user_id == response.data.faculty) {
                this.sessionhandover.toslot = to.pivot.slot;
                this.sessionhandover.tostatus = to.pivot.approval_status;
                this.sessionhandover.tointiated = to.pivot.intiated_by;
                this.sessionhandover.to_session_handover_approval_id = to.pivot.id;
              }
            });
            if ((this.attendenceSwapFilter == 1 && ((this.sessionhandover.to_session_handover_approval_id > 0 && handover.approval_status !=0)|| this.sessionhandover.from_session_handover_approval_id > 0))
              || (handover.fromcourse_user.length > 0 && this.attendenceSwapFilter == 3 && (this.sessionhandover.fromintiated == 1 && (handover.approval_status == 0 || handover.approval_status == 1 || this.sessionhandover.from_session_handover_approval_id == null)))
              || (handover.fromcourse_user.length > 0 && this.attendenceSwapFilter == 5 && (this.sessionhandover.fromslot == 0 && handover.approval_status != 0 && handover.approval_status != 1 && this.sessionhandover.fromintiated == 1))
              || (this.attendenceSwapFilter == 2 && (handover.approval_status == 1 || (this.sessionhandover.to_session_handover_approval_id == null && handover.approval_status == 0)))
              || (handover.tocourse_user.length > 0 && this.attendenceSwapFilter == 4 && (this.sessionhandover.toslot == 1 && handover.approval_status != 0 )&& this.sessionhandoverfromintiated != 1)) {
              this.sessionhandoverarray.push({
                id: handover.id,
                fromcourse_user: handover.fromcourse_user,
                fromsubgroup: handover.fromsubgroup,
                fromsession: handover.fromsession,
                from_date: handover.from_date,
                tocourse_user: handover.tocourse_user,
                reason: handover.reason,
                approval_status: handover.approval_status,
                fromslot: this.sessionhandover.fromslot,
                fromstatus: this.sessionhandover.fromstatus,
                fromintiated: this.sessionhandover.fromintiated,
                from_session_handover_approval_id: this.sessionhandover.from_session_handover_approval_id,
                toslot: this.sessionhandover.toslot,
                tostatus: this.sessionhandover.tostatus,
                tointiated: this.sessionhandover.tointiated,
                to_session_handover_approval_id: this.sessionhandover.to_session_handover_approval_id
              });
            }
          });

      } catch (error) {
        // Log an error message if the API request fails
        console.error('Error fetching attendance swap data:', error);
      }
    },

    async sessionhandoverRequest() {
      await axios
        .post(
          this.$store.getters.getAPIKey.mainAPI + "/attendance/sessionhandover",
          {
            from_slot: this.selectedSlots,
            mutualswap: this.mutualswap,
            sessionhandover: this.sessionhandover,
          }
        )
        .then(() => {
          this.$toast.success('Request intiate successfully', {
            position: "top",
            duration: 3000,
          });
          this.sessionhandover.course_user_ids=[];
        })
        

      this.sessionhandover.selectedFaculty = null;
      this.sessionhandover.selectedclass = null;
      this.sessionhandover.reason = null;
      this.mutualswap.selectedFaculty = null;
      this.mutualswap.selectedclass = null;
      this.mutualswap.selectedsession = null;
      this.mutualswap.selecteddate = null;
      this.mutualswap.selectedcourse = null;
      this.mutualswap.selectedclass_type = null;
      this.mutualswap.reason = null;
      this.mutualswap.sessionlength = null;

      this.$bvModal.hide('mutualswapModal');
      this.$bvModal.hide('sessionHandoverModal');
    },
    updateSessioncourseuserid(course_user_id) {
      if (this.sessionhandover.course_user_ids.includes(course_user_id)) {
        this.sessionhandover.course_user_ids = course_user_id;
      }
    },
     async sessionHandover() {
      this.facultyOptions = [];
      this.classoptions = [];
      this.sessionhandover.selectedFaculty = null;
      this.sessionhandover.selectedclass = null;
      this.sessionhandover.reason = null;
      this.mutualswap.selectedFaculty = null;
      this.mutualswap.selectedclass = null;
      this.mutualswap.selectedsession = null;
      this.mutualswap.selecteddate = null;
      this.mutualswap.selectedcourse = null;
      this.mutualswap.selectedclass_type = null;
      this.mutualswap.reason = null;
      this.mutualswap.sessionlength = null;


      const url1 = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.selectedSlots.subgroup_id}/courses/withinstructors?interdepartmental_courses=1&attendence=1`;
      await axios
        .get(url1)
        .then((response) => {
          this.facultyOptions = response.data;
        })
        .catch((error) => {
          error;
        });

      this.courseInstructorArray = []; //clear
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.selectedSlots.subgroup_id}/courses/withinstructors?interdepartmental_courses=1&`;

      await axios
        .get(url)
        .then((response) => {
          var coursesInstructors = response.data;
          coursesInstructors.forEach((course) => {
            course.institution_users.forEach((instructor) => {
              this.courseInstructorArray.push({
                course_id: course.id,
                course: course.name,
                course_code: course.code,
                instructor: instructor.first_name,
                course_user_deleted_at:instructor.deleted_at,
                instructor_fullname:
                  instructor.first_name + " " + instructor.last_name,
                course_user_id: instructor.course_user_id,
              });
            });
          });
          response;
        })
        .catch((error) => {
          error;
        });
      this.$bvModal.show('sessionHandoverModal');
    },
    async updateSessionhandoverStatus(approval_id, slot, session_hand_over_course, id, status) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendance/sessionhandover/updatestatus`;
      await axios
        .post(
          url,
          {
            session_handover_id: id,
            status: status,
            session_hand_over_course: session_hand_over_course,
            slot: slot,
            session_handover_approval_id: approval_id,
          }
        )
        .then(() => {
          this.$toast.success('Update successfully', {
            position: "top",
            duration: 3000,
          });
          
        })
        this.attendenceSwapList();
    },
    async updateAttendanceSwapStatus(slot, id, status) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/updatestatus`;
      await axios
        .post(
          url,
          {
            attendance_swap_id: id,
            status: status,
            slot: slot,
          }
        )
        .then(() => {
          this.$toast.success('Update successfully', {
            position: "top",
            duration: 3000,
          });
         
        })  
         this.attendenceSwapList(); 
    }, 
    async showMutualSwapPopup() {
      this.resetMutualSwapFields();
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.selectedSlots.subgroup_id}/courses/withinstructors?interdepartmental_courses=1&attendence=1`;
      try {
        const response = await axios.get(url);
        this.facultyOptions = response.data;
        this.$bvModal.show('mutualswapModal');
      } catch (error) {
        console.error("Error fetching faculty options:", error);
      }
    },

    resetMutualSwapFields() {
      this.facultyOptions = [];
      this.subgroupOptions = [];
      this.sessionOptions = [];
      Object.assign(this.mutualswap, {
        selectedFaculty: null,
        selectedSubgroup: null,
        selectedSession: null,
        selectedDate: null,
        selectedCourse: null,
        selectedSubgroupType: null,
        reason: null,
        sessionlength: null,
        to_schedules_length: null,
        from_schedules_length: null
      });
    },

    async checkSessionSwapped() {
      const params = {
        session_id: this.mutualswap.selectedSession,
        date: this.mutualswap.selectedDate,
        faculty: this.mutualswap.selectedFaculty
      };
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/checkselected-session-swaps-status`;

      try {
        const response = await axios.get(url, { params });
        this.mutualswap.swapped_session = response.data;
        if(!this.mutualswap.swapped_session){
          this.checkMultipleFaculty();
        }
        
      } catch (error) {
        console.error("Error checking multiple faculty:", error);
      }
    },

     async checkMultipleFaculty() {
      const params = {
        to_session: this.mutualswap.selectedSession,
        to_date: this.mutualswap.selectedDate,
        to_subgroup: this.mutualswap.selectedSubgroup,
        from_date: this.selectedSlots.date,
        from_session: this.selectedSlots.sessions,
        from_subgroup: this.selectedSlots.subgroup_id,
      };
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/checkmultipletofaculties`;
      try {
        const response = await axios.get(url, { params });
        this.mutualswap.to_schedules_length = response.data.to_schedules;
        this.mutualswap.from_schedules_length = response.data.from_schedules;
      } catch (error) {
        console.error("Error checking multiple faculty:", error);
      }
    },

    async mutualUserSubGroupList() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/mutualusersubgroups?faculty=${this.mutualswap.selectedFaculty}`;
      try {
        const response = await axios.get(url);
        this.subgroupOptions = response.data.usersubgroups.map(({ id, name, type }) => ({
          value: id,
          text: name,
          type,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } catch (error) {
        console.error("Error fetching user subgroups:", error);
      }
    },

    async checkClassType() {
      const selectedSubgroup = this.subgroupOptions.find(
        subgroup => subgroup.value === this.mutualswap.selectedSubgroup
      );
      if (selectedSubgroup) {
        this.mutualswap.selectedSubgroupType = selectedSubgroup.type;
      }

      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/mutualswapcourses?to_faculty=${this.mutualswap.selectedFaculty}&from_usersubgroup=${this.selectedSlots.subgroup_id}&to_usersubgroup=${this.mutualswap.selectedSubgroup}`;
      try {
        const response = await axios.get(url);
        this.mutualSwapFromCourseOptions = response.data.fromCourses.map(({ id, name }) => ({
          value: id,
          text: name,
        })).sort((a, b) => a.text.localeCompare(b.text));

        this.mutualSwapToCourseOptions = response.data.toCourses.map(({ id, name }) => ({
          value: id,
          text: name,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } catch (error) {
        console.error("Error fetching mutual swap courses:", error);
      }
    },

    async mutualswapSessionlist() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupschedules?usersubgroup=${this.mutualswap.selectedSubgroup}&faculty=${this.mutualswap.selectedFaculty}&date=${this.mutualswap.selectedDate}`;
      try {
        const response = await axios.get(url);
        this.sessionOptions = response.data.map(({ session }) => ({
          value: session.id,
          text: session.name,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } catch (error) {
        console.error("Error fetching session options:", error);
      }
    },

    async initiateSwapRequest() {
      this.swapRequestSave = true;
      await this.$v.$touch();

      if (this.$v.$invalid) {
        const tabHeight = document.getElementById("staffListTab__BV_tab_container_");
        this.$smoothScroll({
          container: tabHeight,
          scrollTo: document.querySelector(".form-group-error"),
          duration: 1000,
          offset: -120,
        });
        this.submitStatus = "ERROR";
        this.swapRequestSave = false;
        return;
      }

      const payload = {
        from_slot: this.selectedSlots,
        mutualswap: this.mutualswap,
        sessionhandover: this.sessionhandover,
      };
      try {
        await axios.post(`${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps`, payload);
        this.$toast.success("Request initiated successfully", {
          position: "top",
          duration: 3000,
        });
        this.resetMutualSwapFields();
        this.clearSlotSelection();
        this.$bvModal.hide('mutualswapModal');
      } catch (error) {
        error;
      } finally {
        this.swapRequestSave = false;
      }
    },
     async submitattendanceunlock() {
      this.enable_unlock_proceed = false;
      const url = this.$store.getters.getAPIKey.mainAPI + `/attendanceunlocks`;
      await this.$axios
        .post(url, {
          date: this.selectedSlots.date,
          sessions: this.selectedSlots.sessions,
          course: this.selectedSlots.course_id,
          subgroup_id: this.selectedSlots.subgroup_id,
          reason: this.unlock_reason,
          lock: this.selectedSlots.lock
        })
        .then(() => {
          this.$toast.success(
            "Attendance unlock request submitted successfully.",
            {
              position: "top",
              duration: 3000,
            }
          );
        })
        .catch((error) => {
          error;
        });
        this.unlock_reason = null;
        this.enable_unlock_proceed = true;
        this.clearSlotSelection()
        this.$bvModal.hide('unlockAttendanceModel');
    },
    async downloadMySchedulePdf() {
      this.loadingPdf = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/courseschedules/report/pdfexport`;
      await this.$axios
        .post(
          url, {}, { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "faculty_personal_schedules.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.downloadData = false;
        })
        .catch(() => {
          this.$toast.error('Failed to download', {
            position: "top",
            duration: 7000,
          });
        });
      this.loadingPdf = false;
    },
    openEditCourseAttendanceFormWithReportMainTab() {
      // open in Main Content area 
      this.$root.subContent.subContentComponent = "editCourseAttendanceFormWithReport";
      this.$root.subContent.subContentData = {};
      this.$root.subContent.enableMainContent = false;
    },
    markNewAttendanceFromCustomDate(selectedSlots) {
      this.$bvModal.hide('customDateAttendanceMarkModel');
      this.markAttendanceFor = selectedSlots;
      this.$bvModal.show('studentsAttendanceMarkingFormModel');
      // this.$emit('markNewAttendance', selectedSlots)
    },
    markNewAttendance() {
      // this.selectedSlots;
      let tempDate = new Date(this.selectedSlots.date).toLocaleDateString();
      let sessionNames = '';
      let tempCourse = this.courses[this.selectedSlots.course_id];
      this.selectedSlots.sessions.forEach(sessionId => {
        sessionNames += this.sessionObjects[sessionId].name + ', '
      });
      this.selectedSlots.confirm_text = 'Mark attendance for ' +
        tempCourse.name + ' '
        + tempCourse.usersubgroup.code + ' on ' + tempDate + ' and sessions: ' + sessionNames;

      // this.$emit('markNewAttendance', this.selectedSlots)
      this.markAttendanceFor = this.selectedSlots;
      this.$bvModal.show('studentsAttendanceMarkingFormModel');
    },
    selectScheduleSlot(student_attendances, date, sessionId, courseId, attendance_status, holiday, suspend, lock, pending, subgroup_id, type, swap_pending, handover_pending, swapped, handover) {
      // clear selection if date/course/flags mismatch
      if (
        (this.selectedSlots.date != date) ||
        (this.selectedSlots.course_id != courseId) ||
        (this.selectedSlots.lock != lock) ||
        (this.selectedSlots.unlock_Pending != pending) ||
        this.selectedSlots.swapped ||
        this.selectedSlots.swap_pending ||
        this.selectedSlots.handover ||
        this.selectedSlots.handover_pending
      ) {
        this.clearSlotSelection();
      }

      // toggle session in/out of selection
      if (this.selectedSlots.sessions.includes(sessionId)) {
        let idx = this.selectedSlots.sessions.indexOf(sessionId);
        this.selectedSlots.sessions.splice(idx, 1);
        if (this.selectedSlots.allAttendances) {
          this.selectedSlots.allAttendances.splice(idx, 1);
        }
      } else {
        if (lock || pending) {
          // 🚀 Locked/pending slot → just allow without validation
          this.selectedSlots.sessions.push(sessionId);
        } else {
          // 🚀 Normal slot → apply validation
          if (this.selectedSlots.sessions.length > 0) {
            let allAttendances = this.selectedSlots.allAttendances || [];
            allAttendances.push(student_attendances);

            let allNull = allAttendances.every(a => !a || a.length === 0);
            let allNotNull = allAttendances.every(a => a && a.length > 0);

            if (!(allNull || allNotNull)) {
              alert("Attendance data variation identified across the selected sessions. Please select individual sessions to proceed with editing attendance.");
              return;
            }

            if (allNotNull) {
              let reference = allAttendances[0];
              let isConsistent = allAttendances.every(slot =>
                reference.length === slot.length &&
                reference.every(ref => {
                  let cmp = slot.find(s => s.attendee_id === ref.attendee_id);
                  return cmp && cmp.attendance_type_id === ref.attendance_type_id;
                })
              );
              if (!isConsistent) {
                alert("Attendance data variation identified across the selected sessions. Please select individual sessions to proceed with editing attendance.");
                return;
              }
            }

            this.selectedSlots.allAttendances = allAttendances;
          } else {
            this.selectedSlots.allAttendances = [student_attendances];
          }

          this.selectedSlots.sessions.push(sessionId);
        }
      }

      // 🔑 Common assignments (always executed)
      this.selectedSlots.student_attendances = student_attendances;
      this.selectedSlots.holiday = holiday;
      this.selectedSlots.suspend = suspend;
      this.selectedSlots.subgroup_id = subgroup_id;
      this.selectedSlots.subgroup_type = type;
      this.selectedSlots.unlock_Pending = pending;
      this.selectedSlots.lock = lock;
      this.selectedSlots.swapped = swapped;
      this.selectedSlots.swap_pending = swap_pending;
      this.selectedSlots.handover = handover;
      this.selectedSlots.handover_pending = handover_pending;
      this.selectedSlots.date = date;
      this.selectedSlots.course_id = courseId;
      this.selectedSlots.already_marked = attendance_status !== '';

      if (this.selectedSlots.sessions.length < 1) {
        this.clearSlotSelection();
      }

      this.$forceUpdate();
    },

    clearSlotSelection() {
      this.selectedSlots.student_attendances = [];
      this.selectedSlots.date = '';
      this.selectedSlots.sessions = [];
      this.selectedSlots.course_id = '';
      this.selectedSlots.confirm_text = '';
      this.selectedSlots.already_marked = false;
      this.selectedSlots.holiday = false;
      this.selectedSlots.suspend = false;
      this.selectedSlots.swapped = false;
      this.selectedSlots.swap_pending = false;
      this.selectedSlots.handover = false;
      this.selectedSlots.handover_pending = false;
      this.markAttendanceFor.date = '';
      this.markAttendanceFor.sessions = [];
      this.markAttendanceFor.course_id = '';
      this.markAttendanceFor.confirm_text = '';
      // this.markAttendanceFor.already_marked= false;
    },

    // selectNonScheduleSlot(date, sessionId, courseId) {
    //   if (this.selectedSlots.date == date) { // select slot on same date then add / remove session only
    //     if (this.selectedSlots.sessions.includes(sessionId)) {
    //       this.selectedSlots.sessions.splice(this.selectedSlots.sessions.indexOf(sessionId), 1);
    //     } else {
    //       this.selectedSlots.sessions.push(sessionId);
    //     }
    //     if (this.selectedSlots.sessions.length < 1) { // clear all
    //       this.selectedSlots.date = '';
    //       this.selectedSlots.sessions = [];
    //       this.selectedSlots.course_id = '';
    //     }
    //   } else { // selected on a different date then reset date course sessions
    //     this.selectedSlots.date = '';
    //     this.selectedSlots.sessions = [];
    //     this.selectedSlots.course_id = '';

    //     this.selectedSlots.date = date;
    //     this.selectedSlots.sessions = [sessionId];
    //     this.selectedSlots.course_id = courseId;
    //   }
    //   this.$forceUpdate();
    // },
    async getMySchedulesAttendances(append = false) {

      if (this.sessions.length < 1) await this.getSessions();
      this.viewMySchedule = append ? true : null;
      if (!append) {
        this.dateSessionScheduleAtts = {};
        this.mySchedulesEnabledSessionIds = [];
        this.start_date = '';
      }
      this.isLoadingMore = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupschedules/myschedulesattendances?start_date=${this.start_date}`;
      var responseData = [];
      await this.$axios
        .get(url)
        .then((response) => {
          responseData = response.data;          
        })
        .catch((error) => {
          error;
          this.viewMySchedule = false;
          this.isLoadingMore = false;
        });

      this.isLoadingMore = false;      
      this.viewMySchedule = true;
      if (responseData.emptySchedule && !append)
        this.viewMySchedule = false;

      if(responseData.emptySchedule == false && responseData.min_date < responseData.dateRangeFrom || responseData.emptySchedule == true && responseData.min_date < responseData.dateRangeFrom)
        this.viewLoadMore = true;    
      else
        this.viewLoadMore = false;

      let tempMySchedulesEnabledSessionIds = [];
      for (const date in responseData.dateSessionScheduleAtts) {
        const sessionsData = responseData.dateSessionScheduleAtts[date];
        for (const sessionId in sessionsData) {
          // const sessionData = sessions[sessionId];
          if (!tempMySchedulesEnabledSessionIds.includes(sessionId))
            tempMySchedulesEnabledSessionIds.push(sessionId);
        }
      }

      // reorder schedule sessions ids
      this.mySchedulesEnabledSessionIds = [];
      this.sessions.forEach(session => {
        if (tempMySchedulesEnabledSessionIds.includes(`${session.id}`))
          this.mySchedulesEnabledSessionIds.push(`${session.id}`);
      });      


      Object.assign(this.dateSessionScheduleAtts, responseData.dateSessionScheduleAtts);

      this.courses = {
        ...this.courses,
        ...responseData.courses
      };

      this.start_date = responseData.dateRangeFrom;
      // setTimeout(() => {
      //   this.scrollToToday()
      // }, 1500);
    },

    async getSessions() {
      this.sessionObjects = {};
      const url = this.$store.getters.getAPIKey.createSessions;
      await this.$axios
        .get(url)
        .then((response) => {
          this.sessions = response.data;
          this.sessions.forEach(session => {
            this.sessionObjects[session.id] = session;
          });
        })
        .catch((error) => {
          error;
        });
    },
    scrollToToday() {
      let el = this.$refs.todaySchedule;
      el.scrollIntoView({ behavior: "smooth" });
    },
    successAttendanceMarkForm() {
      this.$bvModal.hide('studentsAttendanceMarkingFormModel');
      this.clearSlotSelection();
      // this.selectedSlots.date = '';
      // this.selectedSlots.sessions = [];
      // this.selectedSlots.course_id = '';
      // this.markAttendanceFor.date = '';
      // this.markAttendanceFor.sessions = [];
      // this.markAttendanceFor.course_id = '';
    },
    cancelAttendanceMarkForm() {
      this.$bvModal.hide('studentsAttendanceMarkingFormModel');
      this.clearSlotSelection();
      // this.markAttendanceFor.date = '';
      // this.markAttendanceFor.sessions = [];
      // this.markAttendanceFor.course_id = '';
    },
  },
};
</script>

<style  >
body{
  overflow-y: auto;
}
.c-border {
  border: 2px solid;
}

.holiday-schedule {
  background-color: rgb(223, 219, 97);
}

.suspended-schedule {
  background-color: rgb(255, 126, 126);
}

.selected-slot {
  background-color: rgb(186, 186, 186) !important;
}

.attendance-table-container{
  height: 100% !important;
}

.black-border th,
.black-border td,
.black-border tr {
  border: 1px solid rgb(175, 175, 175);
}

.blink_me {
  animation: blinker 1.5s linear infinite;
  color: forestgreen;
}
</style>
